module.exports = __webpack_public_path__ + "img/product-edi-invoice.802c5fb7.svg";